import PropTypes from 'prop-types'
import React from 'react'
import { NavLink } from 'react-router-dom'
import styles from './_shortcuts.css'
import { FormattedMessage } from 'react-intl'

export default function Shortcuts ({ userId }) {
  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        <h2 className={styles.title}>
          <FormattedMessage
            id='shortcuts.title'
            defaultMessage='Shortcuts'
          />
        </h2>
        <ul className={styles.list}>
          <li className={styles.item}>
            <a className={styles.link} href='/routes/create/'>
              <FormattedMessage id='shortcuts.create_route' defaultMessage='Create Route' />
            </a>
          </li>
          <li className={styles.item}>
            <NavLink to='/workout/create' className={styles.link} activeClassName='active'>
              <FormattedMessage id='shortcuts.log_workout' defaultMessage='Log Workout' />
            </NavLink>
          </li>
          <li className={styles.item}>
            <a className={styles.link} href='/workout/import/dashboard/'>
              <FormattedMessage id='shortcuts.import_workout' defaultMessage='Import Workout' />
            </a>
          </li>
          <li className={styles.item}>
            <NavLink to={`/profile/${userId}/goals/create/`} className={styles.link} activeClassName='active'>
              <FormattedMessage id='shortcuts.create_a_goal' defaultMessage='Create a goal' />
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  )
}

Shortcuts.propTypes = {
  userId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
}
